export default "__VITE_ASSET__CqF5M$Ov__"